import SxDef from '@core/types/SxDef';

const useSx = (): SxDef => ({
  pagination: { margin: 'auto' },
});

export default useSx;
